import { render } from "./ThirdPark.vue?vue&type=template&id=890e4558&scoped=true"
import script from "./ThirdPark.vue?vue&type=script&lang=js"
export * from "./ThirdPark.vue?vue&type=script&lang=js"

import "./ThirdPark.vue?vue&type=style&index=0&id=890e4558&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-890e4558"]])

export default __exports__